export const headerData=['版本名称','商品名称','基础版本','小版本','标签', '包装指令单号',
  '近效期天数','近产期天数','复检天数','是否可用']
export const filterVal=['name','item','first','second','third','fourth',
  'daysOfExpirationNearly','daysOfProductionNearly','daysOfInspectionNearly','available']
export const excelName='商品版本信息'